// MUI twin of design/ui.tsx EmptyState. Dashed-border placeholder panel: icon +
// title + optional hint. Prop API matches the kt original verbatim.
import { Box } from "@mui/material";
import type { ReactNode } from "react";
import { brainTokens } from "../design/brainTheme";
import { Icon } from "../design/ui";

const c = brainTokens.color;

export function EmptyState({
  icon = "circle-check",
  title,
  children,
}: {
  icon?: string;
  title: string;
  children?: ReactNode;
}) {
  return (
    <Box
      sx={{
        textAlign: "center",
        padding: "40px 20px",
        color: c.muted,
        border: `1px dashed ${c.border}`,
        borderRadius: `${brainTokens.radius.panel}px`,
      }}
    >
      <Icon name={icon} size={28} color={c.faint} style={{ display: "block", margin: "0 auto 8px" }} />
      <Box sx={{ fontSize: 15, fontWeight: 500, lineHeight: 1.4, color: c.ink }}>{title}</Box>
      {children && (
        <Box sx={{ fontSize: 12, color: c.faint, mt: "4px" }}>{children}</Box>
      )}
    </Box>
  );
}
